/**
 * Chat Components - Context-switching chat widgets for Copilot panel
 *
 * Schema-driven components (preferred):
 * - ChatPanel: Renders sections based on CHAT_SCHEMA
 * - ChatPanelLoader: Handles entity-specific data fetching
 * - ChatSectionRenderer: Dispatches to section components
 *
 * Legacy entity-specific components:
 * - ProjectChat, RFQChat, VendorChat, VendorResponseChat
 *
 * Shared components for building chat UIs:
 * - ContactSelector: Searchable contact dropdown
 * - ContactList: Simple contact list display
 * - WhatsAppCompose: Message composition area
 * - LoadingState, EmptyState, ErrorState: Common UI states
 *
 * @layer presentation
 * @arch_domain copilot
 */

// Schema-driven components (preferred)
export { ChatPanel } from './chat-panel';
export { ChatPanelLoader } from './chat-panel-loader';
export { ChatSectionRenderer } from './chat-section-renderer';
export { MessagesSection, WhatsAppSendSection, ChatterPostSection } from './sections';

// Legacy entity-specific components
export { ProjectChat } from './project-chat';
export { RFQChat } from './rfq-chat';
export { VendorChat } from './vendor-chat';
export { VendorResponseChat } from './vendor-response-chat';

// Shared components (for building custom chat UIs)
export { ContactSelector, ContactList } from './contact-selector';
export { WhatsAppCompose, WhatsAppComposeWithContactSelector } from './whatsapp-compose';
export { LoadingState, EmptyState, ErrorState } from './shared';
